// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getAttributesApi } from "../../Service/Api/AttributesApi"
import { getAttributesList,getErrors } from "../Reducer/AttributesReducer"
 
 


// Watchers
function* attributesListSaga() {
	yield takeEvery("attributes_list/getAttributes", getAllAttributes)
}

// Sagas
function* getAllAttributes(action) {
	// console.log(action)
	try {
		const getAttributes = yield call(getAttributesApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getAttributes.request.status === 200) {
			yield put(getAttributesList(getAttributes))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(attributesListSaga)])
}
